import { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext();

const themes = {
  dark: {
    name: 'Oscuro',
    colors: {
      background: '#13162a',
      backgroundLight: '#112240',
      text: '#fff',
      textSecondary: '#8892b0',
      accent: '#fcbf49',
      accentLight: '#fef08a',
      accentSecondary: '#1d4ed8',
    }
  },
  light: {
    name: 'Claro',
    colors: {
      background: '#F0F4F8',
      backgroundLight: '#FFFFFF',
      text: '#1E213A',
      textSecondary: '#4A5568',
      accent: '#0E9F6E',
      accentLight: '#34D399',
      accentSecondary: '#E6FFFA',
    }
  },
  blue: {
    name: 'Azul',
    colors: {
      background: '#0f4c75',
      backgroundLight: '#1b5d8b',
      text: '#bbe1fa',
      textSecondary: '#3282b8',
      accent: '#ff6b6b',
      accentLight: '#ff9b9b',
      accentSecondary: '#1b262c',
    }
  },
  purple: {
    name: 'Púrpura',
    colors: {
      background: '#2d1b2e',
      backgroundLight: '#3f2b40',
      text: '#ffffff',
      textSecondary: '#b8c1ec',
      accent: '#ff6b6b',
      accentLight: '#ff9b9b',
      accentSecondary: '#845ec2',
    }
  },
};

export const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(true);
  const [currentTheme, setCurrentTheme] = useState('dark');

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    const savedMode = localStorage.getItem('mode');
    if (savedTheme && themes[savedTheme]) {
      setCurrentTheme(savedTheme);
    }
    if (savedMode) {
      setIsDarkMode(savedMode === 'dark');
    }
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    const theme = themes[currentTheme];

    Object.entries(theme.colors).forEach(([key, value]) => {
      root.style.setProperty(`--color-${key}`, value);
    });

    // Aplicar la clase de tema
    Object.keys(themes).forEach(themeName => {
      root.classList.remove(`theme-${themeName}`);
    });
    root.classList.add(`theme-${currentTheme}`);

    if (isDarkMode) {
      root.classList.add('dark');
      root.classList.remove('light-mode');
      root.classList.remove('theme-light');
    } else {
      root.classList.add('light-mode');
      root.classList.remove('dark');
      root.classList.remove('theme-dark');
    }

    localStorage.setItem('theme', currentTheme);
    localStorage.setItem('mode', isDarkMode ? 'dark' : 'light');
  }, [currentTheme, isDarkMode]);

  const setTheme = (themeName) => {
    if (themes[themeName]) {
      setCurrentTheme(themeName);
    }
  };

  const toggleTheme = () => {
    setIsDarkMode(prev => !prev);
  };

  return (
    <ThemeContext.Provider value={{ isDarkMode, toggleTheme, currentTheme, setTheme, themes }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);